import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Text from 'antd/lib/typography/Text';

import { readLatestFrameStorage } from 'utils/remember-latest-frame';
import { readRecentJobs, RecentJob } from 'utils/recent-jobs';
import { sharedThumbnailLoader } from 'utils/frame-thumbnails';
import { t } from 'utils/i18n';

// the last jobs the user opened, each with the frame it was left on
export default function ContinueRow(): JSX.Element | null {
    const [jobs] = useState<RecentJob[]>(() => readRecentJobs());
    const [thumbs, setThumbs] = useState<Record<string, string>>({});

    useEffect(() => {
        let cancelled = false;
        const frames = readLatestFrameStorage();
        jobs.forEach((job) => {
            const loader = sharedThumbnailLoader(job.referenceId === null ? 'jobs' : 'reference_jobs', job.jobId);
            loader.load(frames.get(job.jobId) ?? 0)
                .then((url) => { if (!cancelled) setThumbs((prev) => ({ ...prev, [job.path]: url })); })
                .catch(() => undefined);
        });
        return () => { cancelled = true; };
    }, [jobs]);

    if (!jobs.length) return null;
    return (
        <section className='cvat-projects-continue' aria-label={t('Continue')}>
            <Text type='secondary' strong>{t('Continue')}</Text>
            <div className='cvat-projects-continue-row'>
                {jobs.map((job) => (
                    <Link key={job.path} to={job.path} className='cvat-projects-continue-card'>
                        {thumbs[job.path] ? (
                            <img src={thumbs[job.path]} alt='' />
                        ) : (
                            <span className='cvat-projects-continue-placeholder' />
                        )}
                        <span className='cvat-projects-continue-text'>
                            <strong>{job.title}</strong>
                            <Text type='secondary'>
                                {[job.subtitle, job.referenceId === null ? t('Drawings') : t('Photos')].filter(Boolean).join(' · ')}
                            </Text>
                        </span>
                    </Link>
                ))}
            </div>
        </section>
    );
}
